module.exports = __webpack_public_path__ + "bb228b7b2c16cd3936951b5742e3b4c0.svg";